import ReactDOM from 'react-dom/client';
import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import "./assets/css/app.css";
import {AuthProvider} from './app/providers/AuthProvider';
import Home from "./app/pages/Home";
import NotFoundPage from "./app/pages/NotFoundPage";
//import {SignIn} from "./app/components/SignIn";
import {SignOut} from "./app/components/SignOut";
import ServiceUnavailable from "./app/pages/ServiceUnavailable";
import {Environment} from "./shared-api/helpers/Environment";
import {LoginInitiator} from "./app/components/login/LoginInitiator";
import {LoginCallback} from "./app/components/login/LoginCallback";
import {RemuneracaoCrudPage} from "./app/pages/RemuneracaoCrudPage";

export const Init = () => {
    
    const routes = [
        {path: 'home', element: <Home/>},
        //{path: 'signin', element: <SignIn/>},
        {path: 'logininitiator', element: <LoginInitiator/>},
        {path: 'logincallback', element: <LoginCallback/>},
        {path: 'signout', element: <SignOut/>},
        {path: 'notfound', element: <NotFoundPage/>},
        {path: 'serviceunavailable', element: <ServiceUnavailable/>},

        {path: 'acesso/interno/configuracao/auth/:token', element: <RemuneracaoCrudPage/>}

    ];

    return (
        <Routes>
            {/*<Route path="/" element={<Home/>}/>*/}
            {routes.map(({element, path}) => <Route key={path} path={path} element={element}/>)}
            <Route path="*" element={<Navigate to='/notfound'/>}/>
            <Route index element={<Navigate to='/logininitiator'/>}/>{/* raiz do sistema ele manda para a pagina de logininitiator*/}
        </Routes>
    );
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <BrowserRouter basename={Environment.get('REACT_APP_CONTEXT')}>
        <AuthProvider>
            <Init/>
        </AuthProvider>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
